import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

/**
 * EmptyState — terminal-style empty placeholder.
 */
export function EmptyState({ children }: Props) {
  return (
    <div className="border border-dashed border-border p-8 text-center">
      <div className="font-mono text-2xs text-ink-dim uppercase tracking-widest">
        ░░ EMPTY ░░
      </div>
      <div className="mt-3 font-mono text-sm text-ink-muted">{children}</div>
    </div>
  );
}

interface LoadingProps {
  label?: string;
}

export function LoadingState({ label = "LOADING" }: LoadingProps) {
  return (
    <div className="font-mono text-2xs text-ink-muted uppercase tracking-widest p-6 text-center">
      <span className="cursor-blink">{label}</span>
    </div>
  );
}

interface ErrorProps {
  error: string;
  onRetry?: () => void;
}

export function ErrorState({ error, onRetry }: ErrorProps) {
  return (
    <div className="border border-status-failed p-4">
      <div className="font-mono text-2xs text-status-failed uppercase tracking-widest">
        ▓▓ ERROR ▓▓
      </div>
      <div className="mt-2 font-mono text-sm text-ink-primary">{error}</div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-3 font-mono text-2xs uppercase tracking-widest text-ink-muted hover:text-terminal border border-border-strong px-2 py-1"
        >
          [ RETRY ]
        </button>
      )}
    </div>
  );
}